import React, { ReactNode, useState, useEffect } from 'react'
import { RawIntlProvider } from 'react-intl'
import { intl, subscribeToLocaleChanges } from '../utils/intl'

export const I18nProvider = ({ children }: { children: ReactNode }) => {
  const [locale, setLocale] = useState(navigator.language)

  useEffect(() => {
    const unsubscribeFromLocaleChanges = subscribeToLocaleChanges(setLocale)
    return () => {
      unsubscribeFromLocaleChanges()
    }
  }, [])

  return (
    <RawIntlProvider value={intl} key={locale}>
      {children}
    </RawIntlProvider>
  )
}
